export default __webpack_public_path__ + "static/media/8.d8b958db.jpeg";